// If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.
import Vue from 'vue'

// Vue Router
// The official router for Vue.js.
// https://github.com/vuejs/vue-router
import VueRouter from 'vue-router'

// Store
import store from '@/store'

// Define route components.
// These can be imported from other files
import Auth from '@/views/auth/Auth'
import CmsAplicacao from '@/views/cms/CmsAplicacao'
import FormEsqueciMinhaSenha from '@/components/auth/forms/FormEsqueciMinhaSenha'
import FormLogin from '@/components/auth/forms/FormLogin'
import FormRecuperarSenha from '@/components/auth/forms/FormRecuperarSenha'
import FormSelecionaOperadora from '@/components/auth/forms/FormSelecionaOperadora'
import FormValidaContexto from '@/components/auth/forms/FormValidaContexto'
import MensageriaAplicacao from '@/views/mensageria/MensageriaAplicacao'
import NotFound from '@/views/NotFound.vue'
import PainelConfiguracoes from '@/views/painel-configuracoes/PainelConfiguracoes'
import dashHome from '@/views/dashboard/Home.vue'
import tokenRefresher from '@/services/token-refresher'
import { searchMenuToId } from '@/utils/utils'
import chatHelpManager from '@/services/chat-help.manager'
import HomeAplications from '@/views/dashboard/HomeAplications.vue'
import FuncionalidadeHandler from '@/views/dashboard/FuncionalidadeHandler.vue'
import MinhaConta from '@/views/embeds/MinhaConta.vue'

// Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  {
    path: '/auth',
    component: Auth,
    name: 'Auth',
    redirect: '/auth/cliente',
    children: [
      {
        path: 'cliente',
        component: FormValidaContexto,
        name: 'FormValidaContexto',
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'login',
        component: FormLogin,
        name: 'FormLogin',
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'seleciona-operadora',
        component: FormSelecionaOperadora,
        name: 'FormSelecionaOperadora',
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'esqueci-minha-senha',
        component: FormEsqueciMinhaSenha,
        name: 'FormEsqueciMinhaSenha',
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'recuperar-senha',
        component: FormRecuperarSenha,
        name: 'FormRecuperarSenha',
        meta: {
          requiresAuth: false
        }
      }
    ]
  },
  // DashBoard
  // {
  //   path: '/',
  //   component: PainelAplicacoes,
  //   name: 'Painel',
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: Dashboard,
  //       name: 'Dashboard',
  //       meta: {
  //         requiresAuth: true
  //       }
  //     }
  //   ]
  // },
  // Configurações
  {
    path: '/',
    component: PainelConfiguracoes,
    name: 'AplicationHome',
    redirect: '/home',
    children: [
      {
        component: dashHome,
        meta: {
          requiresAuth: true,
          idMenu: 9,
          routerName: 'Home'
        },
        name: 'Home',
        path: 'home',
        props: true
      },
      {
        path: 'minha-conta',
        component: MinhaConta,
        name: 'MinhaConta',
        meta: {
          requiresAuth: true,
          idMenu: 1,
          routerName: 'MinhaConta'
        }
      }
    ]
  },
  {
    path: '/plataforma/:idConfigClienteApp',
    component: PainelConfiguracoes,
    name: 'PainelConfiguracoes',
    children: [
      {
        component: HomeAplications,
        meta: {
          requiresAuth: true,
          idMenu: 9,
          routerName: 'HomeAplication'
        },
        name: 'HomeAplication',
        path: '',
        props: true
      },
      {
        component: FuncionalidadeHandler,
        meta: {
          requiresAuth: true,
          idMenu: 9,
          routerName: 'funcionalidadeHandler'
        },
        name: 'funcionalidadeHandler',
        path: ':funcionalidade',
        props: true
      }
    ]
  },
  {
    path: '/mensageria-selecionar-aplicacao',
    component: MensageriaAplicacao,
    name: 'MensageriaAplicacao',
    props: true,
    meta: {
      requiresAuth: true,
      idMenu: 7,
      routerName: 'Mensageria'
    }
  },
  {
    path: '/cms-selecionar-aplicacao',
    component: CmsAplicacao,
    name: 'CmsAplicacao',
    props: true,
    meta: {
      requiresAuth: true,
      idMenu: 6,
      routerName: 'CmsAplicacao'
    }
  },
  // Página não encontrada
  { path: '/404', component: NotFound },
  // Qualquer rota desconhecida, redireciona para 404
  { path: '*', redirect: '/404' }
]

Vue.use(VueRouter)

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes // short for `routes: routes`
})

// Global Navigation Guards
// https://router.vuejs.org/guide/advanced/navigation-guards.html#global-guards

router.beforeEach(async (to, from, next) => {
  await tokenRefresher.checkToken(to, next)
})

router.beforeEach((to, from, next) => {
  if (window.onbeforeunload) {
    try {
      if (window.confirm(window.onbeforeunload())) {
        window.onbeforeunload = null
        return next()
      } else {
        return next(false)
      }
    } catch (e) {
      return next()
    }
  } else {
    return next()
  }
})

router.beforeEach(async (to, from, next) => {
  const token = store.getters['login/token']
  const userPermissions = store.state.login.permissaoRouter
  store.commit('setCurrentMenu', {
    ...searchMenuToId(store.getters['menus'], to.params.funcionalidade).menu,
    currentRouterName: to.meta.routerName
  })
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const operadora = store.getters['login/operadora']
    if (!token) {
      next({ name: 'FormLogin' })
    } else if (!operadora || (operadora && !operadora.clientKey.length)) {
      next({ name: 'FormSelecionaOperadora' })
    } else if (!userPermissions || userPermissions.length === 0) {
      return next({ name: 'Auth' })
    } else if (to.meta.routerName === 'funcionalidadeHandler' && to.params.funcionalidade && !userPermissions.includes(to.params.funcionalidade)) {
      next({ name: 'HomeAplication' })
    } else {
      next()
    }
  } else if (to.name === 'FormLogin') {
    const contexto = store.getters['login/contexto']
    if (!contexto || (contexto && !contexto.slug.length)) {
      next({ name: 'Auth' })
    } else {
      next()
    }
  } else if (to.name === 'FormSelecionaOperadora') {
    const operadoras = store.getters['login/operadoras']
    if (!token) {
      next({ name: 'FormLogin' })
    } else if (operadoras.length === 1) {
      next({ name: 'Home' })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  const chatVisible = to && to.meta && to.meta.showChatHelp
  chatHelpManager.changeChatVisibility(chatVisible)
  next()
})

export default router
